import { compressToGzipBase64 } from "./utils";
import { initializeSocket } from "./socketConnectionManager";

function checkSocketConnection(listId) {
  try {
    if (!process.env.REACT_APP_IS_WEB_SOCKET_ENABLED) {
      return false;
    } else if (!window.appStore.socket || !window.appStore.socket.auth.token) {
      console.log("Socket is not initialized.");
      initializeSocket(listId);
      return true;
    } else if (!window.appStore.socket.connected) {
      console.log("Socket is not connected, retrying...");
      window.appStore.socket.connect();
      checkProperConnectionViaPingPong();
      return true;
    }
    return false;
  } catch (error) {
    console.log('Socket connection checking failed.');
  }
}

export function handleSocketConnection(listId = '') {
  try {
      let check = checkSocketConnection(listId ? listId : window.appStore.containerStore.listId);

      if (!check && process.env.REACT_APP_IS_WEB_SOCKET_ENABLED) {
        console.log("Connected to WebSocket server1010");
        const accountDetails = {
            clientId: window.appStore.clientId,
            domain: window.LOGGED_IN_USER.domain,
            userId: window.LOGGED_IN_USER.user_id,
            userName: window.LOGGED_IN_USER.full_name,
            email: window.LOGGED_IN_USER.email,
            listId: listId ? listId : window.appStore.containerStore.listId
        };

        window.appStore?.socket.emit('user-connected', accountDetails);
      }
  } catch (error) {
      console.error("Error: ", error);
  }
}

export function handleUpdatingData(nodeData = '', newRowsData = '', listId, isSubsheet = false) {
    try {
      checkSocketConnection(listId ? listId : window.appStore.containerStore.listId);

      if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && listId && (nodeData || newRowsData) && (isSubsheet || window.appStore?.containerStores[listId]?.view?.type == "table")) {
        const compressedModifiedData = nodeData ? compressToGzipBase64(nodeData) : "";
        const compressedNewRowsData = newRowsData ? compressToGzipBase64(newRowsData) : "";
        if (compressedModifiedData || compressedNewRowsData) {
          const payload = {
            clientId: window.appStore.clientId,
            domain: window.LOGGED_IN_USER.domain,
            userId: window.LOGGED_IN_USER.user_id,
            userName: window.LOGGED_IN_USER.full_name,
            email: window.LOGGED_IN_USER.email,
            listId: listId,
            modifiedData: compressedModifiedData,
            newRowsData: compressedNewRowsData,
            isSubsheet: isSubsheet,
            parentRowIds: isSubsheet ? JSON.stringify([window.appStore.containerStores[listId]?.currentSubsheetStore?.parentRowId]) : 0
          };
          if (window.appStore?.socket && window.appStore?.socket.connected) {
            window.appStore?.socket.emit('update-data', payload);
          } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
            const onConnect = () => {
              window.appStore?.socket.emit('update-data', payload);
              window.appStore?.socket.off('connect', onConnect);
            };
            window.appStore?.socket.on('connect', onConnect);
          }
        }
      }
    } catch (error) {
      console.log('Error ', error);
    }
}

export function handleRowDeletion(rowIdsList = '', listId = '', isSubsheet = false) {
    try {
      checkSocketConnection(listId ? listId : window.appStore.containerStore.listId);

      if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && listId && rowIdsList && (isSubsheet || window.appStore?.containerStores[listId]?.view?.type == "table")) {
        const compressedRowIdsList = rowIdsList ? compressToGzipBase64(rowIdsList) : "";
        if (compressedRowIdsList) {
          const payload = {
            clientId: window.appStore.clientId,
            domain: window.LOGGED_IN_USER.domain,
            userId: window.LOGGED_IN_USER.user_id,
            userName: window.LOGGED_IN_USER.full_name,
            email: window.LOGGED_IN_USER.email,
            listId: listId,
            rowIdsList: compressedRowIdsList,
            isSubsheet: isSubsheet,
            parentRowIds: isSubsheet ? JSON.stringify([window.appStore.containerStores[listId]?.currentSubsheetStore?.parentRowId]) : 0
          };
          if (window.appStore?.socket && window.appStore?.socket.connected) {
            window.appStore?.socket.emit('update-deleted-rows', payload);
          } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
            const onConnect = () => {
              window.appStore?.socket.emit('update-deleted-rows', payload);
              window.appStore?.socket.off('connect', onConnect);
            };
            window.appStore?.socket.on('connect', onConnect);
          }
        }
      }
    } catch (error) {
      console.log('Error ', error);
    }
}

export function handleSubsheetDataUpdationThroughForm(modifiedSubsheetData, listId, parentRowId) {
  try {
    checkSocketConnection(listId);

    if (listId) {
      const compressedSubsheetData = modifiedSubsheetData ? compressToGzipBase64(modifiedSubsheetData) : "";
      if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && compressedSubsheetData) {
        const payload = {
          clientId: window.appStore.clientId,
          domain: window.LOGGED_IN_USER.domain,
          userId: window.LOGGED_IN_USER.user_id,
          userName: window.LOGGED_IN_USER.full_name,
          email: window.LOGGED_IN_USER.email,
          listId: listId,
          modifiedSubsheetData: compressedSubsheetData,
          parentRowId: parentRowId ? parentRowId : 0
        };
        if (window.appStore?.socket && window.appStore?.socket.connected) {
          window.appStore?.socket.emit('update-subsheet-data', payload);
        } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
          const onConnect = () => {
            window.appStore?.socket.emit('update-subsheet-data', payload);
            window.appStore?.socket.off('connect', onConnect);
          };
          window.appStore?.socket.on('connect', onConnect);
        }
      }
    }
  } catch (error) {
    console.log('Error ', error);
  }
}

export function handleCommentsData(commentsData = '', commentsCount = '0', rowId = '', uniqueId ='', listId = '') {
    try {
      checkSocketConnection(listId);

      if (process.env.REACT_APP_IS_WEB_SOCKET_ENABLED && listId && rowId && window.appStore?.containerStores[listId]?.view?.type == "table") {
        const compressedCommentsData = commentsData ? compressToGzipBase64(commentsData) : "";
        if (compressedCommentsData) {
          const payload = {
            clientId: window.appStore.clientId,
            domain: window.LOGGED_IN_USER.domain,
            userId: window.LOGGED_IN_USER.user_id,
            userName: window.LOGGED_IN_USER.full_name,
            email: window.LOGGED_IN_USER.email,
            listId: listId,
            commentsData: compressedCommentsData,
            commentsCount: commentsCount,
            rowId: rowId,
            uniqueId: uniqueId
          };
          if (window.appStore?.socket && window.appStore?.socket.connected) {
            window.appStore?.socket.emit('update-comments', payload);
          } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
            const onConnect = () => {
              window.appStore?.socket.emit('update-comments', payload);
              window.appStore?.socket.off('connect', onConnect);
            };
            window.appStore?.socket.on('connect', onConnect);
          }
        }
      }
    } catch (error) {
      console.log('Error ', error);
    }
}

export function checkProperConnectionViaPingPong() {
  try {
    window.appStore?.socket.emit('ping-check');
    setTimeout(() => {
      if (window.appStore.pongReceived) {
        window.appStore.pongReceived = false;
      } else {
        initializeSocket();
      }
    }, 3000);
  } catch (error) {
    console.log('PingPong Error', error);
  }
}

export function handleAddEditColumn(column = '', decimals = 0, listId, isSubsheet = false, isOldColumn = false, shouldRefreshData = false, shouldRedrawRefreshedRows = false, parentListId = 0) {
  try {
    checkSocketConnection(listId ? listId : window.appStore.containerStore.listId);

    if (listId && column && (isSubsheet || window.appStore?.containerStores[listId]?.view?.type == "table") && process.env.REACT_APP_IS_WEB_SOCKET_ENABLED) {
      const compressedColumnData = column ? compressToGzipBase64(column) : ""; //Data to be given to this func should be stringified
      if (compressedColumnData) {
        const payload = {
          clientId: window.appStore.clientId,
          domain: window.LOGGED_IN_USER.domain,
          userId: window.LOGGED_IN_USER.user_id,
          userName: window.LOGGED_IN_USER.full_name,
          email: window.LOGGED_IN_USER.email,
          listId: listId,
          columnData: compressedColumnData,
          decimals: decimals,
          isSubsheet: isSubsheet,
          parentListId: parentListId,
          isOldColumn: isOldColumn,
          shouldRefreshData: shouldRefreshData,
          shouldRedrawRefreshedRows: shouldRedrawRefreshedRows
        };
        if (window.appStore?.socket && window.appStore?.socket.connected) {
          window.appStore?.socket.emit('add-edit-column', payload);
        } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
          const onConnect = () => {
            window.appStore?.socket.emit('add-edit-column', payload);
            window.appStore?.socket.off('connect', onConnect);
          };
          window.appStore?.socket.on('connect', onConnect);
        }
      }
    }
  } catch (error) {
    console.log('Error ', error);
  }
}

export function handleDeletingColumn(columnId, listId, isSubsheet, parentListId = 0) {
  try {
    checkSocketConnection(listId ? listId : window.appStore.containerStore.listId);

    if (listId && columnId && (isSubsheet || window.appStore?.containerStores[listId]?.view?.type == "table") && process.env.REACT_APP_IS_WEB_SOCKET_ENABLED) {
      const payload = {
        clientId: window.appStore.clientId,
        domain: window.LOGGED_IN_USER.domain,
        userId: window.LOGGED_IN_USER.user_id,
        userName: window.LOGGED_IN_USER.full_name,
        email: window.LOGGED_IN_USER.email,
        listId: listId,
        columnId: columnId,
        isSubsheet: isSubsheet,
        parentListId: parentListId
      };
      if (window.appStore?.socket && window.appStore?.socket.connected) {
        window.appStore?.socket.emit('delete-column', payload);
      } else if (window.appStore?.socket && !window.appStore?.socket.connected) {
        const onConnect = () => {
          window.appStore?.socket.emit('delete-column', payload);
          window.appStore?.socket.off('connect', onConnect);
        };
        window.appStore?.socket.on('connect', onConnect);
      }
    }
  } catch (error) {
    console.log('Error ', error);
  }
}